import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FunctionService, ThemeService } from 'vhobjects-service';

@Component({
  selector: 'app-color-contrast',
  templateUrl: './color-contrast.component.html',
  styleUrls: ['./color-contrast.component.scss']
})
export class ColorContrastComponent implements OnInit {
  /** Danh sách màu để chọn */
  colorList: any[] = [
    { name: 'aliceblue', hex: '#F0F8FF', rgb: '240, 248, 255' },
    { name: 'antiquewhite', hex: '#FAEBD7', rgb: '250, 235, 215' },
    { name: 'aqua', hex: '#00FFFF', rgb: '0, 255, 255' },
    { name: 'aquamarine', hex: '#7FFFD4', rgb: '127, 255, 212' },
    { name: 'azure', hex: '#F0FFFF', rgb: '240, 255, 255' },
    { name: 'beige', hex: '#F5F5DC', rgb: '245, 245, 220' },
    { name: 'bisque', hex: '#FFE4C4', rgb: '255, 228, 196' },
    { name: 'black', hex: '#000000', rgb: '0, 0, 0', color: 'white' },
    { name: 'blanchedalmond', hex: '#FFEBCD', rgb: '255, 235, 205' },
    { name: 'blue', hex: '#0000FF', rgb: '0, 0, 255', color: 'white' },
    { name: 'blueviolet', hex: '#8A2BE2', rgb: '138, 43, 226', color: 'white' },
    { name: 'brown', hex: '#A52A2A', rgb: '165, 42, 42', color: 'white' },
    { name: 'burlywood', hex: '#DEB887', rgb: '222, 184, 135' },
    { name: 'cadetblue', hex: '#5F9EA0', rgb: '95, 158, 160' },
    { name: 'chartreuse', hex: '#7FFF00', rgb: '127, 255, 0' },
    { name: 'chocolate', hex: '#D2691E', rgb: '210, 105, 30' },
    { name: 'coral', hex: '#FF7F50', rgb: '255, 127, 80' },
    { name: 'cornflowerblue', hex: '#6495ED', rgb: '100, 149, 237' },
    { name: 'cornsilk', hex: '#FFF8DC', rgb: '255, 248, 220' },
    { name: 'crimson', hex: '#DC143C', rgb: '220, 20, 60', color: 'white' },
    { name: 'cyan', hex: '#00FFFF', rgb: '0, 255, 255' },
    { name: 'darkblue', hex: '#00008B', rgb: '0, 0, 139', color: 'white' },
    { name: 'darkcyan', hex: '#008B8B', rgb: '0, 139, 139' },
    { name: 'darkgoldenrod', hex: '#B8860B', rgb: '184, 134, 11' },
    { name: 'darkgray', hex: '#A9A9A9', rgb: '169, 169, 169' },
    { name: 'darkgreen', hex: '#006400', rgb: '0, 100, 0', color: 'white' },
    { name: 'darkkhaki', hex: '#BDB76B', rgb: '189, 183, 107' },
    { name: 'darkmagenta', hex: '#8B008B', rgb: '139, 0, 139', color: 'white' },
    { name: 'darkolivegreen', hex: '#556B2F', rgb: '85, 107, 47', color: 'white' },
    { name: 'darkorange', hex: '#FF8C00', rgb: '255, 140, 0' },
    { name: 'darkorchid', hex: '#9932CC', rgb: '153, 50, 204', color: 'white' },
    { name: 'darkred', hex: '#8B0000', rgb: '139, 0, 0', color: 'white' },
    { name: 'darksalmon', hex: '#E9967A', rgb: '233, 150, 122' },
    { name: 'darkseagreen', hex: '#8FBC8F', rgb: '143, 188, 143' },
    { name: 'darkslateblue', hex: '#483D8B', rgb: '72, 61, 139', color: 'white' },
    { name: 'darkslategray', hex: '#2F4F4F', rgb: '47, 79, 79', color: 'white' },
    { name: 'darkturquoise', hex: '#00CED1', rgb: '0, 206, 209' },
    { name: 'darkviolet', hex: '#9400D3', rgb: '148, 0, 211', color: 'white' },
    { name: 'deeppink', hex: '#FF1493', rgb: '255, 20, 147' },
    { name: 'deepskyblue', hex: '#00BFFF', rgb: '0, 191, 255' },
    { name: 'dimgray', hex: '#696969', rgb: '105, 105, 105', color: 'white' },
    { name: 'dodgerblue', hex: '#1E90FF', rgb: '30, 144, 255' },
    { name: 'firebrick', hex: '#B22222', rgb: '178, 34, 34', color: 'white' },
    { name: 'floralwhite', hex: '#FFFAF0', rgb: '255, 250, 240' },
    { name: 'forestgreen', hex: '#228B22', rgb: '34, 139, 34' },
    { name: 'fuchsia', hex: '#FF00FF', rgb: '255, 0, 255' },
    { name: 'gainsboro', hex: '#DCDCDC', rgb: '220, 220, 220' },
    { name: 'ghostwhite', hex: '#F8F8FF', rgb: '248, 248, 255' },
    { name: 'gold', hex: '#FFD700', rgb: '255, 215, 0' },
    { name: 'goldenrod', hex: '#DAA520', rgb: '218, 165, 32' },
    { name: 'gray', hex: '#808080', rgb: '128, 128, 128' },
    { name: 'green', hex: '#008000', rgb: '0, 128, 0', color: 'white' },
    { name: 'greenyellow', hex: '#ADFF2F', rgb: '173, 255, 47' },
    { name: 'honeydew', hex: '#F0FFF0', rgb: '240, 255, 240' },
    { name: 'hotpink', hex: '#FF69B4', rgb: '255, 105, 180' },
    { name: 'indianred', hex: '#CD5C5C', rgb: '205, 92, 92' },
    { name: 'indigo', hex: '#4B0082', rgb: '75, 0, 130', color: 'white' },
    { name: 'ivory', hex: '#FFFFF0', rgb: '255, 255, 240' },
    { name: 'khaki', hex: '#F0E68C', rgb: '240, 230, 140' },
    { name: 'lavender', hex: '#E6E6FA', rgb: '230, 230, 250' },
    { name: 'lavenderblush', hex: '#FFF0F5', rgb: '255, 240, 245' },
    { name: 'lawngreen', hex: '#7CFC00', rgb: '124, 252, 0' },
    { name: 'lemonchiffon', hex: '#FFFACD', rgb: '255, 250, 205' },
    { name: 'lightblue', hex: '#ADD8E6', rgb: '173, 216, 230' },
    { name: 'lightcoral', hex: '#F08080', rgb: '240, 128, 128' },
    { name: 'lightcyan', hex: '#E0FFFF', rgb: '224, 255, 255' },
    { name: 'lightgoldenrodyellow', hex: '#FAFAD2', rgb: '250, 250, 210' },
    { name: 'lightgray', hex: '#D3D3D3', rgb: '211, 211, 211' },
    { name: 'lightgreen', hex: '#90EE90', rgb: '144, 238, 144' },
    { name: 'lightpink', hex: '#FFB6C1', rgb: '255, 182, 193' },
    { name: 'lightsalmon', hex: '#FFA07A', rgb: '255, 160, 122' },
    { name: 'lightseagreen', hex: '#20B2AA', rgb: '32, 178, 170' },
    { name: 'lightskyblue', hex: '#87CEFA', rgb: '135, 206, 250' },
    { name: 'lightslategray', hex: '#778899', rgb: '119, 136, 153' },
    { name: 'lightsteelblue', hex: '#B0C4DE', rgb: '176, 196, 222' },
    { name: 'lightyellow', hex: '#FFFFE0', rgb: '255, 255, 224' },
    { name: 'lime', hex: '#00FF00', rgb: '0, 255, 0' },
    { name: 'limegreen', hex: '#32CD32', rgb: '50, 205, 50' },
    { name: 'linen', hex: '#FAF0E6', rgb: '250, 240, 230' },
    { name: 'magenta', hex: '#FF00FF', rgb: '255, 0, 255' },
    { name: 'maroon', hex: '#800000', rgb: '128, 0, 0', color: 'white' },
    { name: 'mediumaquamarine', hex: '#66CDAA', rgb: '102, 205, 170' },
    { name: 'mediumblue', hex: '#0000CD', rgb: '0, 0, 205', color: 'white' },
    { name: 'mediumorchid', hex: '#BA55D3', rgb: '186, 85, 211' },
    { name: 'mediumpurple', hex: '#9370DB', rgb: '147, 112, 219' },
    { name: 'mediumseagreen', hex: '#3CB371', rgb: '60, 179, 113' },
    { name: 'mediumslateblue', hex: '#7B68EE', rgb: '123, 104, 238' },
    { name: 'mediumspringgreen', hex: '#00FA9A', rgb: '0, 250, 154' },
    { name: 'mediumturquoise', hex: '#48D1CC', rgb: '72, 209, 204' },
    { name: 'mediumvioletred', hex: '#C71585', rgb: '199, 21, 133', color: 'white' },
    { name: 'midnightblue', hex: '#191970', rgb: '25, 25, 112', color: 'white' },
    { name: 'mintcream', hex: '#F5FFFA', rgb: '245, 255, 250' },
    { name: 'mistyrose', hex: '#FFE4E1', rgb: '255, 228, 225' },
    { name: 'moccasin', hex: '#FFE4B5', rgb: '255, 228, 181' },
    { name: 'navajowhite', hex: '#FFDEAD', rgb: '255, 222, 173' },
    { name: 'navy', hex: '#000080', rgb: '0, 0, 128', color: 'white' },
    { name: 'oldlace', hex: '#FDF5E6', rgb: '253, 245, 230' },
    { name: 'olive', hex: '#808000', rgb: '128, 128, 0' },
    { name: 'olivedrab', hex: '#6B8E23', rgb: '107, 142, 35' },
    { name: 'orange', hex: '#FFA500', rgb: '255, 165, 0' },
    { name: 'orangered', hex: '#FF4500', rgb: '255, 69, 0' },
    { name: 'orchid', hex: '#DA70D6', rgb: '218, 112, 214' },
    { name: 'palegoldenrod', hex: '#EEE8AA', rgb: '238, 232, 170' },
    { name: 'palegreen', hex: '#98FB98', rgb: '152, 251, 152' },
    { name: 'paleturquoise', hex: '#AFEEEE', rgb: '175, 238, 238' },
    { name: 'palevioletred', hex: '#DB7093', rgb: '219, 112, 147' },
    { name: 'papayawhip', hex: '#FFEFD5', rgb: '255, 239, 213' },
    { name: 'peachpuff', hex: '#FFDAB9', rgb: '255, 218, 185' },
    { name: 'peru', hex: '#CD853F', rgb: '205, 133, 63' },
    { name: 'pink', hex: '#FFC0CB', rgb: '255, 192, 203' },
    { name: 'plum', hex: '#DDA0DD', rgb: '221, 160, 221' },
    { name: 'powderblue', hex: '#B0E0E6', rgb: '176, 224, 230' },
    { name: 'purple', hex: '#800080', rgb: '128, 0, 128', color: 'white' },
    { name: 'red', hex: '#FF0000', rgb: '255, 0, 0' },
    { name: 'rosybrown', hex: '#BC8F8F', rgb: '188, 143, 143' },
    { name: 'royalblue', hex: '#4169E1', rgb: '65, 105, 225', color: 'white' },
    { name: 'saddlebrown', hex: '#8B4513', rgb: '139, 69, 19', color: 'white' },
    { name: 'salmon', hex: '#FA8072', rgb: '250, 128, 114' },
    { name: 'sandybrown', hex: '#F4A460', rgb: '244, 164, 96' },
    { name: 'seagreen', hex: '#2E8B57', rgb: '46, 139, 87' },
    { name: 'seashell', hex: '#FFF5EE', rgb: '255, 245, 238' },
    { name: 'sienna', hex: '#A0522D', rgb: '160, 82, 45', color: 'white' },
    { name: 'silver', hex: '#C0C0C0', rgb: '192, 192, 192' },
    { name: 'skyblue', hex: '#87CEEB', rgb: '135, 206, 235' },
    { name: 'slateblue', hex: '#6A5ACD', rgb: '106, 90, 205', color: 'white' },
    { name: 'slategray', hex: '#708090', rgb: '112, 128, 144' },
    { name: 'snow', hex: '#FFFAFA', rgb: '255, 250, 250' },
    { name: 'springgreen', hex: '#00FF7F', rgb: '0, 255, 127' },
    { name: 'steelblue', hex: '#4682B4', rgb: '70, 130, 180' },
    { name: 'tan', hex: '#D2B48C', rgb: '210, 180, 140' },
    { name: 'teal', hex: '#008080', rgb: '0, 128, 128', color: 'white' },
    { name: 'thistle', hex: '#D8BFD8', rgb: '216, 191, 216' },
    { name: 'tomato', hex: '#FF6347', rgb: '255, 99, 71' },
    { name: 'turquoise', hex: '#40E0D0', rgb: '64, 224, 208' },
    { name: 'violet', hex: '#EE82EE', rgb: '238, 130, 238' },
    { name: 'wheat', hex: '#F5DEB3', rgb: '245, 222, 179' },
    { name: 'white', hex: '#FFFFFF', rgb: '255, 255, 255' },
    { name: 'whitesmoke', hex: '#F5F5F5', rgb: '245, 245, 245' },
    { name: 'yellow', hex: '#FFFF00', rgb: '255, 255, 0' },
    { name: 'yellowgreen', hex: '#9ACD32', rgb: '154, 205, 50' }
  ];
  /** Loại màu chủ đạo */
  mainColorType: 'text_or_icon_color' | 'bg_color' = 'bg_color';
  /** Danh sách màu gợi ý */
  suggestedColors = [];

  // Màu chữ/Màu biểu tượng
  fgHex = '#FFFFFF';
  fgRgb = '255, 255, 255';
  fgLightness = 100;
  fgOriginColor = "#FFFFFF";

  // Màu nền
  bgHex = '#0000FF';
  bgRgb = '0, 0, 255';
  bgLightness = 50;
  bgOriginColor = "#0000FF";

  /** Danh sách cấp độ theo tiêu chuẩn WCAG và có giải thích cho từng cấp độ */
  levelsWCAG = [
    { key: 'AA', tooltip: '*_giai_thich_level_aa_theo_tieu_chuan_wcga' },
    { key: 'AAA', tooltip: '*_giai_thich_level_aaa_theo_tieu_chuan_wcga' }
  ]

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ColorContrastComponent>,
    private functionService: FunctionService,
    public themeService: ThemeService,
  ) { }

  ngOnInit(): void {
    if (this.data?.hasOwnProperty('colorContrast')) {
      // Gán màu text hoặc màu icon từ dữ liệu dialog
      this.initColorFromDataDialog('fg', this.data.colorContrast?.textOrIconColor);
      // Gán màu nền từ dữ liệu dialog
      this.initColorFromDataDialog('bg', this.data.colorContrast?.bgColor);

      // Lắng click ra ngoài (backdrop)
      // đoạn này để đóng mà modal và trả về result, nếu ko sẽ ko cập nhật giao diện
      this.dialogRef.backdropClick().subscribe(() => {
        this.close();
      });
    } else {
      // Gán thanh điều chỉnh độ sáng
      this.fgOriginColor = this.adjustColorLightness(this.fgHex, 50);
      this.bgOriginColor = this.adjustColorLightness(this.bgHex, 50);
    }

    // Gán danh sách màu gợi ý dựa trên màu chủ đạo
    this.suggestedColors = this.getSuggestedColors();
  }

  /** Lấy ra danh sách màu gợi ý */
  getSuggestedColors() {
    switch (this.mainColorType) {
      case 'text_or_icon_color': 
        // return this.suggestForegroundsForBackground(this.fgHex, 6, 5);
        return this.suggestForegroundsForBackgroundEnhanced(this.fgHex, 10);
      case 'bg_color': 
        // return this.suggestForegroundsForBackground(this.bgHex, 6, 5);
        return this.suggestForegroundsForBackgroundEnhanced(this.bgHex, 10);
      default:
        return [];
    }
  }

  /**
   * Khởi tạo giá trị màu ban đầu của vật thể từ dữ liệu dialog
   * @param type Màu nền hoặc màu phụ (Màu chữ hoặc màu biểu tượng)
   * @param value Giá trị màu hex lấy từ data dialog
   */
  initColorFromDataDialog(type: 'fg' | 'bg', value: any) {
    if (value) {
      this[`${type}Hex`] = value ?? '';
      this[`${type}Rgb`] = this.hexToRgbStr(this[`${type}Hex`]);
      this.updateColor(type);
    } else {
      const fgMsg = this.data.colorContrast.typeFgColor == 'text' ? 'chu' : 'bieu_tuong';
      this.functionService.createMessage(
        'error', 
        `chua_co_du_lieu_mau_cho_mau_${type == 'fg' ? fgMsg : 'nen'}`,
        3000
      );
    }
  }

  /**
   * Set màu cho `<select>` chọn màu
   * @param name Tên màu
   * @param type Màu nền hoặc màu phụ (Màu chữ hoặc màu biểu tượng)
   */
  setColor(name: string, type: 'fg' | 'bg') {
    const color = this.colorList.find(c => c.name === name);
    if (color) {
      this[`${type}Hex`] = color.hex;
      this[`${type}Rgb`] = color.rgb;
      this.updateColor(type);
    }
  }

  /**
   * Lấy tên màu gắn vào `<select>` chọn màu
   * @param type Màu nền hoặc màu phụ (Màu chữ hoặc màu biểu tượng)
   */
  getColorName(type: 'fg' | 'bg'): string {
    const color = this.colorList.find(c => c.hex.toLowerCase() === this[`${type}Hex`].toLowerCase());
    return color ? color.name : '';
  }

  /**
   * Cập nhật màu mã `hex` khi chỉnh sửa ô nhập
   * @param type Màu nền hoặc màu phụ (Màu chữ hoặc màu biểu tượng)
   */
  onHexChange(type: 'fg' | 'bg') {
    this[`${type}Rgb`] = this.hexToRgbStr(this[`${type}Hex`]);
    this.updateColor(type);
  }

  /**
   * Cập nhật màu dạng `rgb` khi chỉnh sửa ô nhập
   * @param type Màu nền hoặc màu phụ (Màu chữ hoặc màu biểu tượng)
   */
  onRgbChange(type: 'fg' | 'bg') {
    this[`${type}Hex`] = this.rgbStrToHex(this[`${type}Rgb`]);
    this.updateColor(type);
  }

  /**
   * Cập nhật màu dạng `hex` khi chọn màu ở ô `picker color`
   * @param type Màu nền hoặc màu phụ (Màu chữ hoặc màu biểu tượng)
   */
  onPickerChange(type: 'fg' | 'bg') {
    this[`${type}Rgb`] = this.hexToRgbStr(this[`${type}Hex`]);
    this.updateColor(type);
  }

  onClickSuggestedColors(item, type: 'fg' | 'bg') {
    if (this[`${type}Hex`] == item.hex) return;
    this[`${type}Hex`] = item.hex;
    this[`${type}Rgb`] = this.hexToRgbStr(item.hex);
    this.updateColor(type);
  }

  /**
   * Cập nhật màu
   * @param type Màu nền hoặc màu phụ (Màu chữ hoặc màu biểu tượng)
   * @param found Item được tìm kiếm trong danh sách màu `colorList`
   */
  updateColor(type: 'fg' | 'bg') {
    this.suggestedColors = this.getSuggestedColors();
    this[`${type}Lightness`] = this.getLightness(this[`${type}Hex`]);
    this[`${type}OriginColor`] = this.adjustColorLightness(this[`${type}Hex`], 50);
  }

  /** 
   * Hàm cho thanh điều chỉnh độ sáng 
   * @param event % độ sáng khi nắm kéo thanh điều chỉnh
   * @param type Màu nền hoặc màu phụ (Màu chữ hoặc màu biểu tượng)
   */
  setLightness(event: any, type: 'fg' | 'bg') {
    this[`${type}Lightness`] = event;
    this[`${type}Hex`] = this.adjustColorLightness(this[`${type}Hex`], this[`${type}Lightness`]);
    this[`${type}Rgb`] = this.hexToRgbStr(this[`${type}Hex`]);
    this[`${type}OriginColor`] = this.adjustColorLightness(this[`${type}Hex`], 50);
  }

  /**
   * Chuyển đổi màu mã `hex` sang dạng `rgb`: `string`
   * @param hex Chuỗi màu dạng `hex`
   */
  hexToRgbStr(hex: string): string {
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(x => x + x).join('');
    const num = parseInt(hex, 16);
    return `${(num >> 16) & 255}, ${(num >> 8) & 255}, ${num & 255}`;
  }

  /** 
   * Chuyển đổi màu dạng `rgb` sang mã `hex`: `string`
   * @param rgb Chuỗi màu dạng `rgb`
   */
  rgbStrToHex(rgb: string): string {
    const arr = rgb.split(',').map(x => parseInt(x.trim(), 10));
    return '#' + arr.map(x => x.toString(16).padStart(2, '0')).join('').toUpperCase();
  }

  /**
   * Chuyển đổi từ % độ sáng sang màu dạng `hex` (Từ 0-100)
   * @param hex Chuỗi màu dạng `hex`
   */
  adjustColorLightness(hex: string, lightness: number): string {
    let rgb = this.hexToRgb(hex);
    let hsl = this.rgbToHsl(rgb.r, rgb.g, rgb.b);
    hsl.l = lightness / 100.0;
    let rgb2 = this.hslToRgb(hsl.h, hsl.s, hsl.l);
    return this.rgbToHex(rgb2.r, rgb2.g, rgb2.b);
  }

  /**
   * Lấy ra % độ sáng
   * @param hex Chuỗi màu dạng `hex`
   */
  getLightness(hex: string): number {
    let rgb = this.hexToRgb(hex);
    let hsl = this.rgbToHsl(rgb.r, rgb.g, rgb.b);
    return Math.round(hsl.l * 100);
  }

  /** 
   * Chuyển đổi màu mã `hex` sang dạng `rgb`: `{r, g, b}`
   * @param hex Chuỗi màu dạng `hex`
   */
  hexToRgb(hex: string) {
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(x => x + x).join('');
    let num = parseInt(hex, 16);
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
  }

  /**
   * Chuyển đổi `RGB` sang `HEX`
   * @param r Màu đỏ
   * @param g Màu xanh lá
   * @param b Màu xanh dương
   */
  rgbToHex(r: number, g: number, b: number): string {
    return (
      '#' +
      [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('').toUpperCase()
    );
  }

  /**
   * Chuyển đổi `RGB` sang `HSL`
   * @param r Màu đỏ
   * @param g Màu xanh lá
   * @param b Màu xanh dương
   */
  rgbToHsl(r: number, g: number, b: number) {
    r = r / 255;
    g = g / 255;
    b = b / 255;
    let max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h = 0,
      s = 0,
      l = (max + min) / 2;
    if (max != min) {
      let d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h = h / 6;
    }
    return { h, s, l };
  }

  /**
   * Chuyển đổi `HSL` sang `RGB`
   * @param h Sắc độ
   * @param s Độ bão hoà
   * @param l Độ sáng
   */
  hslToRgb(h: number, s: number, l: number) {
    let r, g, b;
    if (s == 0) {
      r = g = b = l; // achromatic
    } else {
      const hue2rgb = (p: number, q: number, t: number) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };
      let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      let p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
      r: Math.round(r * 255),
      g: Math.round(g * 255),
      b: Math.round(b * 255)
    };
  }

  hueDistanceDeg(aDeg: number, bDeg: number): number {
    const d = Math.abs(aDeg - bDeg) % 360;
    return d > 180 ? 360 - d : d;
  }

  /** 
   * Tính tương phản theo tiêu chuẩn `WCAG` 
   * @param hex Chuỗi màu dạng `hex`
   */ 
  getLuminance(hex: string) {
    const rgb = this.hexToRgb(hex);
    let a = [rgb.r, rgb.g, rgb.b].map(v => {
      v /= 255;
      return v <= 0.03928
        ? v / 12.92
        : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }

  /** Lấy ra tỷ lệ tương phản của 2 màu */
  getContrastRatio(hex1?: any, hex2?: any): number {
    let lum1 = this.getLuminance(hex1 ?? this.fgHex);
    let lum2 = this.getLuminance(hex2 ?? this.bgHex);
    let brightest = Math.max(lum1, lum2);
    let darkest = Math.min(lum1, lum2);
    return parseFloat(((brightest + 0.05) / (darkest + 0.05)).toFixed(2));
  }

  /** Lấy kết quả đạt hay không đạt */
  getWCAGResults(hex1?: any, hex2?: any) {
    // AA: 4.5 for normal text, 3.0 for large text
    // AAA: 7.0 for normal text, 4.5 for large text
    const ratio = this.getContrastRatio(hex1, hex2);
    return {
      AA_small: ratio >= 4.5,
      AA_large: ratio >= 3.0,
      AAA_small: ratio >= 7.0,
      AAA_large: ratio >= 4.5
    };
  }

  /**
   * - Tìm màu có cùng hue (deg) và sat, bằng cách sampling lightness từ 0..1
   * - Trả về hex có contrast >= targetContrast, ưu tiên lightness gần 0.5 (giữ "màu chính" tự nhiên)
   */
  findColorByHueForContrast(mainHex: string, hueDeg: number, sat: number = 1, targetContrast: number = 4.5): { hex: string; contrast: number; l: number } | null {
    const step = 0.02; // sampling step for lightness
    const samples: Array<{ l: number; hex: string; contrast: number }> = [];
    for (let l = 0; l <= 1 + 1e-9; l += step) {
      const rgb = this.hslToRgb((hueDeg % 360) / 360, sat, Math.min(1, Math.max(0, l)));
      const hex = this.rgbToHex(rgb.r, rgb.g, rgb.b);
      const ratio = this.getContrastRatio(hex, mainHex);
      if (ratio >= targetContrast) {
        samples.push({ l, hex, contrast: ratio });
      }
    }
    if (samples.length === 0) return null;
    // choose sample with highest contrast, tie-breaker: lightness closest to 0.5
    samples.sort((a, b) => {
      if (b.contrast !== a.contrast) return b.contrast - a.contrast;
      return Math.abs(a.l - 0.5) - Math.abs(b.l - 0.5);
    });
    return { hex: samples[0].hex.toUpperCase(), contrast: samples[0].contrast, l: samples[0].l };
  }

  /**
   * Gợi ý màu phụ: chỉ push khi contrast >= minContrast
   */
  suggestForegroundsForBackgroundEnhanced(
    mainHex: string,
    count: number = 5,
    minContrast: number = 4.5,
    palette: Array<{ name?: string; hex: string }> = []
  ) {
    mainHex = mainHex.toUpperCase();
  
    const pool: Array<{ hex: string; contrast: number; note?: string; hueDeg?: number }> = [];
  
    const pushIfUnique = (hex: string, contrast: number, note?: string, hueDeg?: number) => {
      const H = hex.toUpperCase();
      if (pool.find(p => p.hex === H)) return;
      if (contrast >= minContrast) pool.push({ hex: H, contrast, note, hueDeg });
    };
  
    // 1) include palette candidates (if they pass)
    for (const p of palette) {
      const h = p.hex.toUpperCase();
      const c = this.getContrastRatio(h, mainHex);
      if (c >= minContrast) pushIfUnique(h, c, p.name || 'palette');
    }
  
    // 2) try complementary / triadic / split-complementary hues first
    const mainRgb = this.hexToRgb(mainHex);
    const mainHsl = this.rgbToHsl(mainRgb.r, mainRgb.g, mainRgb.b);
    const baseHueDeg = Math.round(mainHsl.h * 360);
  
    const strategicOffsets = [180, 120, -120, 150, -150, 30, -30, 60, -60];
    const satLevels = [1.0, 0.9, 0.75, 0.6, 0.45];
  
    for (const off of strategicOffsets) {
      const hue = (baseHueDeg + off + 360) % 360;
      for (const s of satLevels) {
        const found = this.findColorByHueForContrast(mainHex, hue, s, minContrast);
        if (found) pushIfUnique(found.hex, found.contrast, `hue ${hue}° sat ${Math.round(s*100)}%`, hue);
        if (pool.length >= count * 5) break; // enough candidates in pool
      }
      if (pool.length >= count * 5) break;
    }
  
    // 3) sweep whole wheel (every 15-30 deg) to ensure diversity
    if (pool.length < count * 3) {
      const stepDeg = 30; // 12 samples; increase density if needed
      for (let deg = 0; deg < 360; deg += stepDeg) {
        for (const s of [1.0, 0.85, 0.7]) {
          const found = this.findColorByHueForContrast(mainHex, deg, s, minContrast);
          if (found) pushIfUnique(found.hex, found.contrast, `hue ${deg}° sat ${Math.round(s*100)}%`, deg);
        }
      }
    }
  
    // 4) include grayscale extremes if pass (rare but valid)
    const grayLs = [0, 0.08, 0.16, 0.25, 0.33, 0.5, 0.66, 0.83, 1];
    for (const l of grayLs) {
      const rgb = this.hslToRgb(0, 0, l);
      const hex = this.rgbToHex(rgb.r, rgb.g, rgb.b);
      const c = this.getContrastRatio(hex, mainHex);
      if (c >= minContrast) pushIfUnique(hex, c, `gray L${Math.round(l*100)}%`);
    }
  
    // If pool empty => can't find any color that meets minContrast
    if (pool.length === 0) return [];
  
    // 5) select final 'count' items maximizing diversity + contrast
    // Greedy: start with highest contrast, then iteratively pick candidate that maximizes
    // (alpha * contrast_norm + beta * min_hue_distance_norm)
    // Normalize contrast to [0,1] by dividing by maxContrast in pool
    const maxContrast = Math.max(...pool.map(p => p.contrast));
    const contrastWeight = 0.7; // favor contrast
    const diversityWeight = 0.3;
  
    const selected = [];
    // seed: highest contrast
    pool.sort((a, b) => b.contrast - a.contrast);
    const seed = pool.shift()!;
    selected.push({ hex: seed.hex, contrast: seed.contrast, passes: this.getWCAGResults(seed.hex, mainHex), note: seed.note, hueDeg: seed.hueDeg });
    // greedy select
    while (selected.length < count && pool.length > 0) {
      let bestIdx = -1;
      let bestScore = -Infinity;
      for (let i = 0; i < pool.length; i++) {
        const cand = pool[i];
        // contrast normalized
        const contrastNorm = cand.contrast / maxContrast; // in [0,1]
        // compute min hue distance to already selected
        let minHueDist = 180; // max circular distance
        if (cand.hueDeg === undefined) {
          // if hue unknown, approximate from rgb->hsl
          const cRgb = this.hexToRgb(cand.hex);
          cand.hueDeg = Math.round(this.rgbToHsl(cRgb.r, cRgb.g, cRgb.b).h * 360);
        }
        for (const s of selected) {
          if (s.hueDeg === undefined) {
            const sRgb = this.hexToRgb(s.hex);
            s.hueDeg = Math.round(this.rgbToHsl(sRgb.r, sRgb.g, sRgb.b).h * 360);
          }
          const d = this.hueDistanceDeg(cand.hueDeg!, s.hueDeg!);
          if (d < minHueDist) minHueDist = d;
        }
        // normalize hue dist to [0,1] by dividing by 180
        const hueNorm = minHueDist / 180;
        const score = contrastWeight * contrastNorm + diversityWeight * hueNorm;
        if (score > bestScore) { bestScore = score; bestIdx = i; }
      }
      if (bestIdx === -1) break;
      const pick = pool.splice(bestIdx, 1)[0];
      selected.push({ hex: pick.hex, contrast: pick.contrast, passes: this.getWCAGResults(pick.hex, mainHex), note: pick.note, hueDeg: pick.hueDeg });
    }
  
    // 6) ensure final list length <= count (already enforced)
    // sort final by contrast desc for nicer UI
    selected.sort((a, b) => b.contrast - a.contrast);
    // map to Suggestion type
    return selected.map(s => ({ hex: s.hex, contrast: parseFloat(s.contrast.toFixed(2)), passes: s.passes, note: s.note }));
  }

  /**
   * Hàm này để đóng ColorContrastComponent
   */
  close() {
    const result = {
      textOrIconColor: this.fgHex,
      bgColor: this.bgHex,
    }
    this.dialogRef.close(result);
  }
}
